import { propertyValue } from './dood-block-config';

/** `text` keeps the current keyboard. `numeric` opens a digits-only keypad. */
export const FUNNEL_INPUT_CHARSET_VALUES = ['text', 'numeric'] as const;

export type FunnelInputCharset = (typeof FUNNEL_INPUT_CHARSET_VALUES)[number];

export function funnelInputCharsetProperty(blockKey: string) {
  const option = (value: FunnelInputCharset) => ({
    value,
    label: `pages.blocks.${blockKey}.input-charset.options.${value}`,
  });

  return propertyValue({
    type: 'select',
    value: 'text' satisfies FunnelInputCharset,
    options: {
      label: `pages.blocks.${blockKey}.input-charset.label`,
      help: `pages.blocks.${blockKey}.input-charset.help`,
      multiple: false,
      choices: FUNNEL_INPUT_CHARSET_VALUES.map(option),
    },
  });
}
